import React, { forwardRef } from 'react'

import { IconProps } from './types'

const Image = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.5 10.5V13.5H11.5M2.5 10.5V2.5H13.5V13.5H11.5M2.5 10.5L5.5 7.5L11.5 13.5M11 6.25C11 6.94036 10.4404 7.5 9.75 7.5C9.05964 7.5 8.5 6.94036 8.5 6.25C8.5 5.55964 9.05964 5 9.75 5C10.4404 5 11 5.55964 11 6.25Z"
        stroke={color || 'currentColor'}
      />
    </svg>
  ),
)
Image.displayName = 'Image'

export default Image
